class DrKieuIndexedFaq extends HTMLElement {
  connectedCallback() {
    this.controller = new AbortController();
    this.indexLinks = [...this.querySelectorAll('[data-faq-index-link]')];
    this.categories = [...this.querySelectorAll('[data-faq-category]')];

    if (this.indexLinks.length === 0 || this.categories.length === 0) return;

    const { signal } = this.controller;
    window.addEventListener('scroll', this.requestActiveCategoryUpdate, { passive: true, signal });
    window.addEventListener('resize', this.requestActiveCategoryUpdate, { passive: true, signal });

    this.indexLinks.forEach((link) => {
      link.addEventListener(
        'click',
        () => {
          const targetId = link.getAttribute('href')?.slice(1);
          if (targetId) this.setActiveCategory(targetId);
        },
        { signal }
      );
    });

    this.updateActiveCategory();
  }

  disconnectedCallback() {
    this.controller?.abort();

    if (this.animationFrame) {
      window.cancelAnimationFrame(this.animationFrame);
    }
  }

  requestActiveCategoryUpdate = () => {
    if (this.animationFrame) return;

    this.animationFrame = window.requestAnimationFrame(() => {
      this.animationFrame = null;
      this.updateActiveCategory();
    });
  };

  updateActiveCategory() {
    const desktop = window.matchMedia('(min-width: 990px)').matches;
    const mobileIndex = this.querySelector('.dk-indexed-faq__index-column');
    const headerHeight = Number.parseFloat(
      window.getComputedStyle(document.body).getPropertyValue('--header-height')
    ) || 0;
    const activationOffset = desktop
      ? headerHeight + 20
      : headerHeight + 20 + (mobileIndex?.offsetHeight ?? 82) + 30;
    let activeCategory = this.categories[0];

    for (const category of this.categories) {
      if (category.getBoundingClientRect().top > activationOffset) break;
      activeCategory = category;
    }

    this.setActiveCategory(activeCategory.id);
  }

  setActiveCategory(categoryId) {
    this.indexLinks.forEach((link) => {
      if (link.getAttribute('href') === `#${categoryId}`) {
        link.setAttribute('aria-current', 'true');
      } else {
        link.removeAttribute('aria-current');
      }
    });
  }
}

if (!customElements.get('dr-kieu-indexed-faq')) {
  customElements.define('dr-kieu-indexed-faq', DrKieuIndexedFaq);
}
